import { Directive, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConsumerService } from '../shared/services/consumer.service';
import { StartWatchIdleTimer } from '../Services/start-watch-idle-timer.service';
@Directive()
@Injectable({
  providedIn: 'root'
})
export class EnviromentService {
  constructor(
    private consumer: ConsumerService,
    private startWatchIdleTimer: StartWatchIdleTimer
  ) {
  }


  getParameterDinamic() {
    return this.consumer.getNotJWT(environment.jweUrls.URL_GET_PARAMETERS_DINAMIC.url)
      .toPromise().then(response => {
        if (response.status.code === '0') {
          environment.obsicash = response.data;
          this.startWatchIdleTimer.emitStartWatchIdleTimer()
        } else {
          this.startWatchIdleTimer.emitStartWatchIdleTimer()
        }
      });
  }
}
